import React from "react";
import {
    Box,
    Container,
    Typography,
    makeStyles,
    Button,
    Hidden,
    Grid,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { GoUnmute } from "react-icons/go";
import { IoVolumeMuteSharp } from "react-icons/io5";
const useStyles = makeStyles((theme) => ({
    BestSellerBox: {
        padding: "75px 0px 0px",

        [theme.breakpoints.down("sm")]: {
            padding: "50px 0px 25px",
        },
        "& .videoBox": {
            position: "relative",
            width: "100%",
            overflow: "hidden",
            borderRadius: "15px",

            "& video": {
                width: "100%",
                height: "100%",
            },
        },
        "& .iframeBox": {
            height: "360px",
            marginTop: "10px",
        },
        "& .referralImg": {
            position: "absolute",
            bottom: "-75px",
            right: "0",
            maxWidth: "700px",
            width: "auto",
            [theme.breakpoints.down("md")]: {
                maxWidth: "550px",
                right: "0",
                bottom: "0",
            },
            [theme.breakpoints.down("sm")]: {
                maxWidth: "402px",
                right: "0",
                bottom: "0",
                top: "14%",
            },
        },
        "& .updateSection": {
            padding: "24px 30px",
            background: theme.palette.background.blur,
            position: "relative",
            borderRadius: "5px",
            [theme.breakpoints.down("sm")]: {
                padding: "20px 10px",
            },

            "& h1": {
                fontSize: "42px",
                [theme.breakpoints.down("md")]: {
                    fontSize: "36px ",
                },
                [theme.breakpoints.down("sm")]: {
                    fontSize: "27px ",
                },
                "& span": { color: "#22A7F0" },
            },
            "& p": {
                maxWidth: "370px",
                marginBottom: "30px",
            },
        },
    },
}));

export default function Youtubevideo(props) {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Box className={classes.BestSellerBox}>
            <Container>
                <Box className="borderShadowBox">
                    <Box className="updateSection">
                        <Grid container>

                            <Grid item xs={12}>
                                {/* <Box style={{ width: "100%" }}>
                  <video
                    width="100%"
                    controls="false"
                    autoplay="true"
                    loop
                    muted
                    playsinline="true"
                  >
                    <source src="letterdocs/web3domain.mp4" type="video/mp4" />
                  </video>
                </Box> */}
                                <Box
                                    style={{ width: "100%", overflow: "hidden" }}
                                    className="iframeBox"
                                >


                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src="https://www.youtube.com/embed/CMqRqd97rQg"
                                        title="Hovr NFT Market Place explainer video"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; 
                                   encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin"
                                        allowfullscreen
                                    ></iframe>

                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}
